import { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/apiClient";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { BrandHeader } from "@/components/forms/BrandHeader";
import { toast } from "sonner";

const KEYS = [["address", "Address"], ["phone", "Phone"], ["email", "Email"], ["website", "Website"], ["registration", "Company reg / VAT no."], ["footer_note", "PDF footer note"]];

export function BrandingDialog({ open, onOpenChange }) {
  const [b, setB] = useState(null);
  useEffect(() => { if (open) api.get("/forms-settings").then((r) => setB(r.data)).catch(() => {}); }, [open]);
  const save = async () => {
    try { await api.put("/forms-settings", b); toast.success("Branding saved"); onOpenChange(false); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg">
        <DialogHeader>
          <DialogTitle>Form branding</DialogTitle>
          <DialogDescription>Your logo and company name come from your company profile. Add the details to show on every form and PDF.</DialogDescription>
        </DialogHeader>
        {b && (
          <div className="space-y-3">
            <BrandHeader branding={b} />
            <div className="grid grid-cols-2 gap-3">
              {KEYS.map(([k, l]) => (
                <div key={k} className={k === "address" || k === "footer_note" ? "col-span-2" : ""}>
                  <Label className="text-xs">{l}</Label>
                  <Input data-testid={`brand-${k}`} value={b[k] || ""} onChange={(e) => setB({ ...b, [k]: e.target.value })} />
                </div>
              ))}
            </div>
            <Button data-testid="brand-save" onClick={save} className="w-full bg-slate-900 text-white">Save branding</Button>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
